import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Checkbox,
  Col,
  Row,
  Switch,
  // Typography,
  // Skeleton,
} from "antd";
import { DownOutlined, RightOutlined } from "@ant-design/icons";
import "./index.css";
// import { isEmpty } from "lodash";

const Reminders = (props) => {
  //State data section
  // const [remindersMode, setRemindersMode] = useState("");
  const [reminderPartyOpen, setReminderPartyOpen] = useState(false);
  const [reminderYoursOpen, setReminderYoursOpen] = useState(false);
  // const [accountData, setAccountData] = useState({
  //   name: "",
  //   mobileNumber: "",
  //   referralCode: "",
  // });

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Account | Mbook</title>
        </MetaTags>
      </div>

      <Row
        className={
          reminderYoursOpen
            ? "border-solid rounded-md bg-[#ffffff] add-users-main pb-10"
            : "border-solid rounded-md bg-[#ffffff] pb-10"
        }
      >
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24}>
          <div className="flex justify-between pl-[10px] pr-[10px] mt-4">
            <div className="flex">
              <div className="ml-2 account-sub-header">
                <h1 className="text-[18px] mb-[1px] mt-2 font-semibold leading-tight">
                  Reminder Settings
                </h1>
                <p className="text-[12.5px]">
                  Select which reminders are sent to you and your parties
                </p>
              </div>
            </div>
            <div className="mt-3">
              <div className="flex">
                <div className="border rounded-md hover:bg-[#efefef] ml-3 pl-6 pr-6 p-1 cursor-pointer">
                  Cancel
                </div>
                <div className="border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-6 pr-6 p-1.5 cursor-pointer">
                  Save Changes
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Col span={24}>
          <Row className="w-[100%] border border-x-0 border-t-2 border-b-0 mt-3"></Row>
        </Col>
        <Col span={24} className="mb-3 mt-1 pr-4 pl-4">
          <Row>
            <Col span={12} className="pr-4">
              <div className="reminders-card">
                <div>
                  <h1 className="text-[13px] mb-[1px] mt-2 font-semibold leading-tight">
                    Send billing SMS to Party
                  </h1>
                  <p className="text-[11px] mt-1">
                    Send SMS to your Party on creating any transaction
                  </p>
                </div>
                <Switch className="mt-2" />
              </div>
            </Col>
            <Col span={12}>
              <div className="reminders-card">
                <div>
                  <h1 className="text-[13px] mb-[1px] mt-2 font-semibold leading-tight">
                    Get payment reminders on WhatsApp
                  </h1>
                  <p className="text-[11px] mt-1">
                    Get WhatsApp alerts when you have to collect payment from
                    customers
                  </p>
                </div>
                <Switch className="mt-2" />
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={24} className="mt-2 mb-2">
          {/* Party section start */}
          <Row className="w-[100%] flex justify-between bg-gray-50 p-2 border border-x-0 pl-5 pr-5">
            <h1 className="flex text-[11px] account-sub-header font-medium">
              <p className="font-semibold text-[12px] uppercase mr-2">
                To Party
              </p>{" "}
              (Reminders will be sent through SMS)
            </h1>
            {reminderPartyOpen === true ? (
              <DownOutlined
                onClick={() => {
                  setReminderPartyOpen(false);
                }}
              />
            ) : (
              <RightOutlined
                onClick={() => {
                  setReminderPartyOpen(true);
                  setReminderYoursOpen(false);
                }}
              />
            )}
          </Row>
          {reminderPartyOpen === true && (
            <Row className="pl-4 pr-4">
              <Col span={24}>
                <div className="text-center mb-2 mt-2">
                  <h1 className="text-[14px] font-semibold leading-tight">
                    No Data Found
                  </h1>
                </div>
              </Col>
            </Row>
          )}
          {/* Party section end */}

          {/* yours section start */}
          <Row className="w-[100%] flex justify-between bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mb-3">
            <h1 className="flex text-[11px]  account-sub-header font-medium">
              <p className="font-semibold text-[12px] uppercase mr-2">To You</p>{" "}
              (Reminders will be sent on Mobile App and WhatsApp)
            </h1>
            {reminderYoursOpen === true ? (
              <DownOutlined
                onClick={() => {
                  setReminderYoursOpen(false);
                }}
              />
            ) : (
              <RightOutlined
                onClick={() => {
                  setReminderYoursOpen(true);
                  setReminderPartyOpen(false);
                }}
              />
            )}
          </Row>
          {/* your open bar functionality */}
          {reminderYoursOpen === true && (
            <Row className="pl-4 pr-4">
              <Col span={12} className="pr-4">
                <div className="reminders-yours-card">
                  <div>
                    <h1 className="text-[13px] mb-[1px] mt-2 font-semibold leading-tight">
                      Sales Invoice
                    </h1>
                    <p className="text-[11px] mt-1">
                      Get reminded to collect payments on time
                    </p>
                  </div>
                  <div className="mt-3 flex justify-between">
                    <p className="text-[13px]">3 days before due date</p>
                    <Checkbox />
                  </div>
                  <div className="mt-3 mb-3 flex justify-between">
                    <p className="text-[13px]">On due date</p>
                    <Checkbox />
                  </div>
                </div>
              </Col>
              <Col span={12} className="pr-4">
                <div className="reminders-yours-card">
                  <div>
                    <h1 className="text-[13px] mb-[1px] mt-2 font-semibold leading-tight">
                      Low Stock
                    </h1>
                    <p className="text-[11px] mt-1">
                      Get reminded to buy stock
                    </p>
                  </div>
                  <div className="mt-3 mb-3 flex justify-between">
                    <p className="text-[13px]">
                      When stock is below low stock level
                    </p>
                    <Checkbox />
                  </div>
                </div>
              </Col>

              <Col span={24}>
                <Row className="w-[103.5%] ml-[-24px] border border-x-0 border-t-1 border-b-0 mt-3 mb-3"></Row>
              </Col>

              <Col span={12} className="pr-4">
                <div className="reminders-yours-card">
                  <div>
                    <h1 className="text-[13px] mb-[1px] mt-2 font-semibold leading-tight">
                      Purchase Invoice
                    </h1>
                    <p className="text-[11px] mt-1">
                      Get reminded to send payments on time
                    </p>
                  </div>
                  <div className="mt-3 flex justify-between">
                    <p className="text-[13px]">3 days before due date</p>
                    <Checkbox />
                  </div>
                  <div className="mt-3 mb-3 flex justify-between">
                    <p className="text-[13px]">On due date</p>
                    <Checkbox />
                  </div>
                </div>
              </Col>
              <Col span={12} className="pr-4">
                <div className="reminders-yours-card">
                  <div>
                    <h1 className="text-[13px] mb-[1px] mt-2 font-semibold leading-tight">
                      Daily Summary
                    </h1>
                    <p className="text-[11px] mt-1">Get daily updates about</p>
                  </div>
                  <div className="mt-3 flex justify-between">
                    <p className="text-[13px]">
                      Outstanding Collections and Payments
                    </p>
                    <Checkbox />
                  </div>
                  <div className="mt-3 mb-3 flex justify-between">
                    <p className="text-[13px]">Yesterday’s Sales</p>
                    <Checkbox />
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {/* yours section end */}
        </Col>
      </Row>

      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </React.Fragment>
  );
};
Reminders.propTypes = {
  location: PropTypes.any,
};

export default Reminders;
